import { NavLink as Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import tugNavigatorData from "../../tugNavigatorData";
import {ReactComponent as HomeIcon} from "../../Asset/home.svg"
import {ReactComponent as RightArrrow} from "../../Asset/arrow-right.svg"
import {ReactComponent as ArrowLeft} from "../../Asset/arrow-left.svg"
import {ReactComponent as RightArrrowB} from "../../Asset/arrow-rightblack.svg"
import "./Tagboat.css";

const Tugboat = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const NavLinkLCss = ({ isActive }) => {
    return {
      backgroundColor: isActive ? "#005EB5" : "",
      color: "white",          
      padding: "10px 15px",
      borderRadius: "30px",
    };
  };

  const navigate = useNavigate();

  const filteredTugs = tugNavigatorData.filter((tug) =>
  tug.name.toLowerCase().includes(searchTerm.toLowerCase())
);

  return (
    <div className="tagboat-container">
      <div className="wrapper">
        <div className="tagboat-header">
          <h2>TUG BOATS</h2>
        </div>
        <div className="tagboat-nav">
          <HomeIcon/>
          <Link to="/Charttering">
            <RightArrrow/> Charttering
          </Link>
          <Link to="/Charttering">
          <RightArrrow/> Vessel Categories
          </Link>
          <Link to="/Charttering">
          <RightArrrow/> Tug Boats
          </Link>
        </div>
      </div>
      <div className="tug-scroll">
        <div className="wrapper">
        <div className="links">
        <ArrowLeft/>
          <Link to='/Tugboat' style={NavLinkLCss}>Tug Boats</Link>
          <Link to='/'>Container Ship</Link>
          <Link to='/'>Dry Bulk</Link>
          <Link to='/'>Oil Tanker</Link>
          <Link to='/'>Tanker</Link>
          <Link to='/'>Cargo Ship</Link>
          <Link to='/'>Gas</Link>
          <Link to='/'>Roll-on/Roll-off</Link>
         <RightArrrowB/>
        </div>
        <span>
              <i className="fa-solid fa-magnifying-glass"></i>
              <input
                type="search"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </span>
        </div>
      </div>
      <div className="tug-nav">
        <h2>Tug Boats</h2>
        <div className="map">
          {filteredTugs.map((tug) => (
            <div
              className="card"
              key={tug.id}
              onClick={() => navigate(`/Tugdetails/${tug.id}`)}
            >
              <img src={tug.imageUrl} alt="" />
              <div className="info">
                <div className="inner">
                  <h3> {tug.name}</h3>
                 <p>{tug.rate}</p>
                </div>
                <div className="inner">
                  <span>Open Port:</span>
                  <p>{tug.openPort}</p>
                </div>
                <div className="inner">
                  <span>Open Date:</span>
                  <p>{tug.openDate}</p>
                </div>
                <div className="inner">
                  <span>DWT:</span>
                  <p>{tug.dwt}</p>
                </div>
                <div className="inner">
                  <span>Built:</span>
                  <p>{tug.built}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tugboat;
